import { useState } from 'react';
import { useQuery } from '@apollo/client';
import AppraiserUnavailableDataMapper from '../../../mappers/AppraiserUnavailableDataMapper';
import GET_UNAVAILABLE_PERIODS from '../../../queries/UnavailablePeriods/getUnavailablePeriodsQuery';

export const useGetUnavailablePeriodsQuery = (queryArgs, isAutoAssignATL) => {
  const { onCompleted } = queryArgs;

  const [excludedDateIntervals, setExcludedDateIntervals] = useState([]);

  const { loading, error } = useQuery(GET_UNAVAILABLE_PERIODS, {
    onCompleted: unavailablePeriodsData => {
      const unavailablePeriods = AppraiserUnavailableDataMapper.toExcludedDateIntervals(
        unavailablePeriodsData.unavailablePeriods
      );
      setExcludedDateIntervals(unavailablePeriods);
      onCompleted(unavailablePeriods);
    },
    skip: !isAutoAssignATL
  });

  return { excludedDateIntervals, loading, error };
};
